import React, { useEffect } from "react";
import "./App.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useTranslation } from "react-i18next";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Method from "./components/Method";
import Strengths from "./components/Strengths";
import Kitchen from "./components/Kitchen";
import Team from "./components/Team";
import Spaces from "./components/Spaces";
import Schedule from "./components/Schedule";
import Reviews from "./components/Reviews";
import FAQ from "./components/FAQ";
import ParentArea from "./components/ParentArea";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminPanel from "./components/AdminPanel";

// Language Wrapper Component: sincronizza URL e lingua i18n
const LanguageWrapper = ({ children, lang }) => {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem('language', lang);
      document.documentElement.lang = lang;
    }
  }, [lang, i18n]);
  
  return children;
};

const HomePage = ({ lang = 'it' }) => {
  return (
    <LanguageWrapper lang={lang}>
      <Header />
      <main>
        <Hero />
        <About />
        <Method />
        <Strengths />
        <Kitchen />
        <Team />
        <Spaces />
        <Schedule />
        <Reviews />
        <FAQ />
        <ParentArea />
        <Contact />
      </main>
      <Footer />
    </LanguageWrapper>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage lang="it" />} />
          <Route path="/en" element={<HomePage lang="en" />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
